<form class="form-redux js-vanity-url-form" id="vanity-url-form" name="vanityForm" method="post" action="{{secureBaseURL}}common/vanity-url.html">
<input type="hidden" name="callback" value="vanityURLCallback" />
<input type="hidden" name="postMessage" value="parent.postMessage" />
<input type="hidden" name="vanityType" value="{{vanityType}}" />
{{#if challengeId}}<input type="hidden" name="challengeId" value="{{challengeId}}" />{{/if}}
<strong>Personalize your web address to make it even easier to share!</strong>
<div class="examples">
	Examples:
	<ul id="vanity-url-examples">
    	{{#each examples}}
    	<li>www.donorschoose.org/{{this}}</li>
    	{{/each}}
    </ul>
</div>
<div id="personalizeURL">
	<p>You can only set this once so choose carefully. Use only lowercase letters, numbers, and hyphens.</p>
	donorschoose.org/<input type="text" name="vanityURL" id="vanityURL" value="" />
	<a id="check-availability-link" class="js-check-availability-link">Check availability</a>
	<div class="error-text"></div>
	<div><a class="button-primary small js-submit-vanity-form-button" id="submitVanityFormButton">Save web address</a></div>
</div>
</form>
